export default class {
  constructor() {
    this.header = document.getElementById('js-header');
    this.headerHeight = this.header.offsetHeight + 20;
    this.lastScrollTop = 0;
    this.ticking = false;
  }

  init() {
    window.addEventListener('scroll', () => {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.updateScroll();
        });
        this.ticking = true;
      }
    });
  }

  updateScroll() {
    const scrollTop = window.scrollY;
    if (this.header.classList.contains('-fixed')) {
      return;
    }
    if (scrollTop > this.lastScrollTop && scrollTop > this.headerHeight) {
      this.header.classList.add('-scrolled');
    } else if (scrollTop < this.headerHeight) {
      this.header.classList.remove('-scrolled');
    }
    this.lastScrollTop = scrollTop;
    this.ticking = false;
  }
}
